import "./locationBillingDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface LocationBillingDetailsViewComponentProps {
    locationBillingDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationBillingDetailsViewComponent = (props: LocationBillingDetailsViewComponentProps) => {
    const {locationBillingDetails, onEditModeOpen, canEdit} = props;
    return (
        <div className={'billing-details-view-component details-tab-data-content'}>
            <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title"> Billing Details</div>
                    {canEdit && <div className={'edit-action-button'}>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Full Name"}> {CommonService.getFullName(locationBillingDetails) || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(locationBillingDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {CommonService.getMaskedMobileNumber(locationBillingDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {locationBillingDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(locationBillingDetails?.secondaryMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Account Executive"}> {locationBillingDetails?.accountExecutiveDetails?.firstName ? CommonService.capitalizeFirstLetterOfEachWord(locationBillingDetails?.accountExecutiveDetails?.firstName + " " + locationBillingDetails?.accountExecutiveDetails?.lastName) : 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                    {
                        locationBillingDetails?.payorMix?.length > 0 && <>
                            <div className="horizontal-line"/>
                            <div className="view-and-edit-title">Payor Mix</div>
                            <div className="details-tab-data-body">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        {
                                            locationBillingDetails?.payorMix?.filter((payorMix: any, index: any) => !(index % 2))
                                                .map((filteredPayorMix: any) => {
                                                    return (
                                                        <div key={filteredPayorMix}
                                                             className="icd-code-title-display">
                                                            <DetailsDataKeyValueComponent
                                                                title={filteredPayorMix?.title}> {`${filteredPayorMix?.estimated} %` || 'N/A'} </DetailsDataKeyValueComponent>
                                                        </div>
                                                    )
                                                })
                                        }

                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        {
                                            locationBillingDetails?.payorMix?.filter((payorMix: any, index: any) => index % 2)
                                                .map((filteredPayorMix: any) => {
                                                    return (
                                                        <div key={filteredPayorMix}
                                                             className="icd-code-title-display">
                                                            <DetailsDataKeyValueComponent
                                                                title={filteredPayorMix?.title}> {`${filteredPayorMix?.estimated} %` || 'N/A'} </DetailsDataKeyValueComponent>
                                                        </div>
                                                    )
                                                })
                                        }
                                    </Grid>

                                </Grid>
                            </div>
                        </>
                    }
                </div>
            </>
        </div>
    );

};

export default LocationBillingDetailsViewComponent;
